const form = {
  formId: "new-user-form",
  formField: {
    period: {
      name: "period",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    exploitationDate: {
      name: "exploitationDate",
      label: "[01a] Ngày khai thác sản lượng:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    additional: {
      name: "additional",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    //
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên tổ chức",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên tổ chức",
    },
    dateOfBirth: {
      name: "dateOfBirth",
      label: "[05] Ngày tháng năm sinh (nếu là cá nhân):",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày sinh",
    },
    taxId: {
      name: "taxId",
      label: "[06] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    identifier: {
      name: "identifier",
      label: "[07] Số CMND/hộ chiếu/CCCD:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số CMND/hộ chiếu/CCCD",
      invalidMsg: "Mã số CMND/hộ chiếu/CCCD không hợp lệ",
    },
    dateRange: {
      name: "dateRange",
      label: "[08] Ngày cấp:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày cấp",
    },
    issuedBy: {
      name: "issuedBy",
      label: "[09] Nơi cấp:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập nơi cấp",
    },
    city: {
      name: "city",
      label: "[10.6] Tỉnh/thành phố:",
      type: "text",
      errorMsg: "Vui lòng chọn thành phố",
    },
    district: {
      name: "district",
      label: "[10.5] Quận/huyện:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn quận huyện",
    },
    ward: {
      name: "ward",
      label: "[10.4] Phường/xã/thị trấn:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn phường",
    },
    village: {
      name: "village",
      label: "[10.3] Tổ/thôn:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn tổ/thôn",
    },
    road: {
      name: "road",
      label: "[10.2] Đường/phố:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn đường/phố",
    },
    apartment: {
      name: "apartment",
      label: "[10.1] Số nhà:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số nhà",
    },
    notificationAddress: {
      name: "notificationAddress",
      label: "[11] Địa chỉ nhận thông báo thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ nhận thông báo thuế",
    },
    phoneNumber: {
      name: "phoneNumber",
      label: "[12] Điện thoại:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
    },
    //
    taxAgentName: {
      name: "taxAgentName",
      label: "[13] Tên tổ chức:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên tổ chức",
    },
    taxAgentId: {
      name: "taxAgentId",
      label: "[14] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế đại lý",
    },
    taxAgentContract: {
      name: "taxAgentContract",
      label: "[09] Hợp đồng đại lý thuế: Số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số hợp đồng đại lý thuế",
    },
    daytaxAgentContract: {
      name: "daytaxAgentContract",
      label: "Ngày:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày",
    },
    //
    plotAddress: {
      name: "plotAddress",
      label: "[16] Địa chỉ lô đất trồng cây lâu năm thu hoạch một lần:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ lô đất trồng cây lâu năm thu hoạch một lần",
    },
    plotAddressCity: {
      name: "plotAddressCity",
      label: "[16.4] Tỉnh/thành phố:",
      type: "text",
      errorMsg: "Vui lòng chọn thành phố",
    },
    plotAddressDistrict: {
      name: "plotAddressDistrict",
      label: "[16.3] Quận/huyện:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn quận huyện",
    },
    plotAddressWard: {
      name: "plotAddressWard",
      label: "[16.2] Phường/xã/thị trấn:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn phường",
    },
    plotAddressVillage: {
      name: "plotAddressVillage",
      label: "[16.1] Tổ/thôn:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tổ/thôn",
    },
    plotNumber: {
      name: "plotNumber",
      label: "[17] Số thửa:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số thửa",
    },
    mapNumber: {
      name: "mapNumber",
      label: "[18] Tờ bản đồ số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số bản đồ",
    },
    acreage: {
      name: "acreage",
      label: "[19] Diện tích lô đất trồng cây lâu năm thu hoạch một lần (ha):",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập diện tích lô đất trồng cây lâu năm thu hoạch một lần (ha)",
    },
    perennialPlant: {
      name: "perennialPlant",
      label: "[20] Loại cây lâu năm thu hoạch một lần:",
      type: "text",
      errorMsg: "Vui lòng nhập tên loại cây lâu năm thu hoạch một lần",
    },
    startingTime: {
      name: "startingTime",
      label: "[21] Thời điểm bắt đầu sử dụng đất:",
      type: "number",
      errorMsg: "Vui lòng chọn thời điểm bắt đầu sử dụng đất",
    },
    timeOfAreaChange: {
      name: "timeOfAreaChange",
      label: "[22] Thời điểm thay đổi diện tích đất:",
      type: "number",
      errorMsg: "Vui lòng chọn thời điểm thay đổi diện tích đất",
    },
    //--------------//
    miningArea: {
      name: "miningArea",
      label: "[23] Diện tích đất khai thác cây lâu năm thu hoạch một lần (ha):",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập diện tích đất khai thác cây lâu năm thu hoạch một lần (ha)",
    },
    catches: {
      name: "catches",
      label: "[24] Sản lượng khai thác cây lâu năm thu hoạch một lần (tấn/ha hoặc m3/ha):",
      type: "number",
      placeholder: "",
      errorMsg:
        "Vui lòng nhập sản lượng khai thác cây lâu năm thu hoạch một lần (tấn/ha hoặc m3/ha)",
    },
    productSellingPrice: {
      name: "productSellingPrice",
      label: "[25] Giá bán một đơn vị sản phẩm tại nơi khai thác (đồng/tấn hoặc đồng/m3):",
      type: "number",
      placeholder: "",
      errorMsg:
        "Vui lòng nhập giá bán một đơn vị sản phẩm tại nơi khai thác (đồng/tấn hoặc đồng/m3)",
    },
    valueOfMiningOutput: {
      name: "valueOfMiningOutput",
      label: "[26] Giá trị sản lượng khai thác [26] = [23] x [24] x [25]:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập giá trị sản lượng khai thác",
    },
    agriculturalLandTax: {
      name: "agriculturalLandTax",
      label: "[26a] Thuế sử dụng đất nông nghiệp phải nộp trước miễn giảm [26a] = [26] x [4%]:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập thuế sử dụng đất nông nghiệp phải nộp trước miễn giảm",
    },
    agriculturalLandTaxExemption: {
      name: "agriculturalLandTaxExemption",
      label: "[27] Thuế sử dụng đất nông nghiệp được miễn, giảm (nếu có):(đồng)",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập thuế sử dụng đất nông nghiệp được miễn, giảm",
    },
    agriculturalLandUseTax: {
      name: "agriculturalLandUseTax",
      label: "[28] Thuế sử dụng đất nông nghiệp phải nộp [28] = ([26] x 4%) - [27]:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập thuế sử dụng đất nông nghiệp phải nộp",
    },
    //--------------//
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
